module.exports = __webpack_public_path__ + "static/media/thumb_GEWO5942_1024.1511ec45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_GEWO5942_1024.jpg
// module id = 134
// module chunks = 0